import React from 'react';
import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  TableCell,
  TableRow,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@mantis-sas/ui";
import { MoreHorizontal, Eye, Edit, Trash2, Package, Hash, CheckCircle, XCircle, Layers, AlertTriangle } from 'lucide-react';
import { formatPrice } from '../Utils/productsSchema';

export const ProductRow = ({ product, onEdit, onDelete, onView }) => {
  // Helper function to display data or fallback
  const displayData = (data, fallback = '—') => {
    return data && data.toString().trim() !== '' ? data : fallback;
  };

  // Get status badge
  
  // Get stock status badge
  
  return (
    <TableRow className="hover:bg-orange-50/30 dark:hover:bg-orange-900/10 transition-colors duration-200 group border-b border-slate-200/60 dark:border-slate-700/60">
      {/* Name Column */}
      <TableCell className="py-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white font-bold text-sm flex-shrink-0 shadow-md ring-2 ring-orange-100 dark:ring-orange-900/30">
            <Package className="h-5 w-5" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-semibold text-slate-900 dark:text-slate-100 truncate group-hover:text-orange-800 dark:group-hover:text-orange-200 transition-colors">
              {displayData(product.name, "Sin nombre")}
            </div>
            {product.description && (
              <div className="text-xs text-slate-500 dark:text-slate-400 truncate">
                {product.description}
              </div>
            )}
          </div>
        </div>
      </TableCell>
      {/* SKU Column */}
      <TableCell className="py-4">
        {product.sku ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex items-center space-x-2 text-sm text-slate-700 dark:text-slate-300 hover:text-orange-600 dark:hover:text-orange-400 cursor-pointer transition-colors">
                  <Hash className="h-4 w-4 text-orange-500 flex-shrink-0" />
                  <span className="truncate font-mono">{product.sku}</span>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>SKU: {product.sku}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <span className="text-slate-400 dark:text-slate-500 text-sm">—</span>
        )}
      </TableCell>
      {/* Price Column */}
      <TableCell className="py-4 text-center">
        {product.price !== undefined && product.price !== null ? (
          <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
            {formatPrice(product.price)}
          </div>
        ) : (
          <span className="text-slate-400 dark:text-slate-500 text-sm">—</span>
        )}
      </TableCell>
      {/* Items Associated Column */}
      <TableCell className="py-4 text-center">
        {product.items && product.items.length > 0 ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex items-center justify-center space-x-2 text-sm text-slate-700 dark:text-slate-300 hover:text-orange-600 dark:hover:text-orange-400 cursor-pointer transition-colors">
                  <Layers className="h-4 w-4 text-orange-500" />
                  <span className="font-medium">{product.items.length}</span>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  {product.items.length} item
                  {product.items.length !== 1 ? "s" : ""} asociado
                  {product.items.length !== 1 ? "s" : ""}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <span className="text-slate-400 dark:text-slate-500 text-sm">0</span>
        )}
      </TableCell>
      {/* Actions Column */}
      <TableCell className="py-4 text-center">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-8 w-8 p-0 text-slate-400 hover:text-slate-600 hover:bg-orange-50 dark:hover:text-slate-300 dark:hover:bg-orange-900/20 transition-colors"
            >
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            {onView && (
              <>
                <DropdownMenuItem
                  onClick={() => onView(product)}
                  className="cursor-pointer text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700"
                >
                  <Eye className="h-4 w-4 mr-2 text-slate-500" />
                  Ver detalles
                </DropdownMenuItem>
                <DropdownMenuSeparator />
              </>
            )}

            <DropdownMenuItem
              onClick={() => onEdit?.(product)}
              className="cursor-pointer text-orange-700 dark:text-orange-300 hover:bg-orange-50 dark:hover:bg-orange-900/20"
            >
              <Edit className="h-4 w-4 mr-2" />
              Editar
            </DropdownMenuItem>

            <DropdownMenuSeparator />

            <DropdownMenuItem
              onClick={() => onDelete?.(product)}
              className="cursor-pointer text-red-700 dark:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Eliminar
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
};

export default ProductRow; 